import ColourPicker from '@/components/ColourPicker';
import { Box, Grid } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useFormikContext } from 'formik';
import React from 'react';

const BrokerageColours = ({ canEdit = true }) => {
	const theme = useTheme();
	const { values, setFieldValue } = useFormikContext();

	const colours = {
		primary: values?.colours?.primary || theme.palette.primary.main,
		secondary: values?.colours?.secondary || '#DADCFF',
		tertiary: values?.colours?.tertiary || '#333333',
	};

	const handleColourChange = (field, newColour) => {
		if (!canEdit) return;
		const colour = String(newColour).includes('#') ? newColour : `#${newColour}`;
		setFieldValue('colours', {
			...colours,
			[field]: colour,
		});
	};

	return (
		<Box sx={{ display: 'flex', justifyContent: 'center', py: 2 }}>
			<Grid container spacing={2} justifyContent='center' sx={{ maxWidth: 800 }}>
				{Object.keys(colours).map((colour) => (
					<Grid size={4} key={colour}>
						<ColourPicker
							label={`${colour.charAt(0).toUpperCase()}${colour.slice(1)} Colour`}
							initialColour={colours[colour]}
							onChange={(newColor) => handleColourChange(colour, newColor)}
							disabled={!canEdit}
						/>
					</Grid>
				))}
			</Grid>
		</Box>
	);
};

export default BrokerageColours;
